import { List } from "@mui/material";
import { useLocation, matchPath } from "react-router-dom";
import SidebarMenuItem from "./item";
import { styled } from "@mui/material/styles";
import { useContext, useState } from "react";
import { mergeMenuItems } from "./helpers";
import { SidebarContext } from "../../../../contexts/SidebarContext";
import { iconForMenu } from "./iconForMenu";

export interface MenuItem {
  link?: string;
  icon?: any;
  badge?: string;
  permission?: string;
  children?: any[];
  name: string;
  superAdminView?: boolean;
  adminView?: boolean;
}

const SubMenuWrapper = styled(List)(
  ({ theme }) => `
    &.MuiList-root {
      .MuiListItem-root {
        padding-inline:10px;
        width: 100% !important;
        .MuiButton-root {
          display: flex;
          color: ${theme.sidebar.menuItemColor};
          background-color: ${theme.sidebar.menuItemBg};
          border: 1px solid transparent;
          text-decoration: none !important;
          width: 100%;
          justify-content: flex-start;
          font-size: ${theme.typography.pxToRem(13)};
          padding-top: ${theme.spacing(0.65)};
          padding-bottom: ${theme.spacing(0.65)};
          position: relative;
          .MuiBadge-root {
            position: absolute;
            right: ${theme.spacing(4)};
            .MuiBadge-standard {
              background: ${theme.colors.primary.main};
              font-size: ${theme.typography.pxToRem(9)};
              font-weight: bold;
              text-transform: uppercase;
              color: ${theme.palette.primary.contrastText};
            }
          }    
          .MuiButton-startIcon,
          .MuiButton-endIcon {
            transition: ${theme.transitions.create(["color"])};
            .MuiSvgIcon-root {
              font-size: inherit;
              transition: none;
            }
          }
          .MuiButton-startIcon {
            font-size: ${theme.typography.pxToRem(22)};
            color: ${theme.sidebar.menuItemColor};
              transition: color 0.3s ease; /* Smooth color transition */

          }          
          .MuiButton-endIcon {
            margin-left: auto;
            color: ${theme.sidebar.menuItemColor};
            font-size: ${theme.typography.pxToRem(22)};
               transition: color 0.3s ease; /* Smooth color transition */

          }
          @keyframes jump {
  0% {
    transform: translateY(0); /* Start at the default position */
  }
  50% {
    transform: translateY(-5px); /* Move upwards */
  }
  100% {
    transform: translateY(0); /* Return to the default position */
  }
}
          &.Mui-active{
            width: 100% !important;
            align-self: flex-start !important;
            background-color: ${theme.sidebar.menuItemBgActive};
            border: 1px solid ${theme.sidebar.menuItemBgActive}; 
            color:${theme.sidebar.menuItemColorActive};
            .MuiButton-startIcon,
            .MuiButton-endIcon {
                color: ${theme.sidebar.menuItemColorActive};
            }
          },
          &:hover {
            border: 1px solid ${theme.sidebar.menuItemBgActive};
             background-color: ${theme.sidebar.menuItemBgActive};
             color: ${theme.sidebar.menuItemColorActive};
              .MuiButton-startIcon,
            .MuiButton-endIcon {
                color: ${theme.sidebar.menuItemColorActive};
                    animation: jump 0.5s ease; /* Trigger the jump animation */

            }
          }
        }

        &.Mui-children {
          flex-direction: column;
          line-height: 1;
        }

        .MuiCollapse-root {
          width: 100%;

          .MuiList-root {
            padding: ${theme.spacing(1, 0)};
            border-bottom:1px solid var(--zs-menuSeparation);
            width:100% !important;
          }

          .MuiListItem-root {
            padding: 1px ${theme.spacing(0)};
            .MuiButton-root {
              color:${theme.sidebar.menuItemColor};
              font-size: ${theme.typography.pxToRem(13)};
              padding: ${theme.spacing(0.5, 2, 0.5, 4.5)};
              .MuiButton-startIcon,
                .MuiButton-endIcon {
                  color:${theme.sidebar.menuItemColor};
                }
              &.Mui-active,
              &:hover {
                color:${theme.sidebar.menuSubItemColorActive};
                background-color: ${theme.sidebar.menuItemBgActive};
                .MuiButton-startIcon,
                .MuiButton-endIcon {
                  color:${theme.sidebar.menuSubItemColorActive};
                }
              }
            }
          }
        }
      }

      .MuiListItem-root {
        margin: 4px 12px;
        width: calc(100% - 24px) !important;
        padding-inline: 0;

        .MuiButton-root {
          border-radius: 50px;
          transition: transform 0.2s ease, box-shadow 0.2s ease;

          .MuiButton-startIcon {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            flex: 0 0 28px;
            width: 28px;
            height: 28px;
            border-radius: 50%;
            background-color: #f0f0f0;
            color: #1976d2;

            .MuiSvgIcon-root {
              color: inherit;
            }
          }

          &.Mui-active {
            background-color: #ebf5ff;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

            .MuiButton-startIcon {
              background-color: #1976d2;
              color: #fff;
            }
          }

          &:hover {
            transform: translateY(-1px);
            box-shadow: 0 4px 10px rgba(0, 0, 0, 0.12);

            .MuiButton-startIcon,
            .MuiButton-startIcon .MuiSvgIcon-root {
              color: #000;
            }
          }

          &.Mui-active:hover .MuiButton-startIcon {
            background-color: #f0f0f0;
          }

          &.Mui-active:hover {
            background-color: #ebf5ff;
          }

        }

        &.sidebar-collapsed {
          .MuiButton-root {
            width: 100%;
            min-width: 0;
            height: 40px;
            min-height: 40px;
            justify-content: center;
            padding: 0;

            .MuiButton-startIcon {
              margin: 0;
            }
          }
        }
      }

      .MuiListItem-root
        .MuiCollapse-root
        .MuiList-root
        .MuiListItem-root
        .MuiButton-root.Mui-active {
        background-color: #ebf5ff;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
      }

      .MuiListItem-root
        .MuiCollapse-root
        .MuiList-root
        .MuiListItem-root
        .MuiButton-root
        .MuiButton-startIcon {
        color: #1976d2;

        .MuiSvgIcon-root {
          color: inherit;
        }
      }

      .MuiListItem-root
        .MuiCollapse-root
        .MuiList-root
        .MuiListItem-root
        .MuiButton-root:hover
        .MuiButton-startIcon {
        color: #000;
      }

      .MuiListItem-root
        .MuiCollapse-root
        .MuiList-root
        .MuiListItem-root
        .MuiButton-root.Mui-active
        .MuiButton-startIcon {
        background-color: #1976d2;
        color: #fff;
      }

      .MuiListItem-root
        .MuiCollapse-root
        .MuiList-root
        .MuiListItem-root
        .MuiButton-root.Mui-active:hover
        .MuiButton-startIcon {
        background-color: #f0f0f0;
        color: #000;
      }
    }
`
);

const renderSidebarMenuItems = ({
  items,
  path,
  openMenu,
  setOpenMenu,
  userData,
}: {
  items: any;
  userData: any;
  path: string;
  openMenu: string[];
  setOpenMenu: Function;
}): JSX.Element => (
  <SubMenuWrapper key={items.path}>
    {items?.reduce(
      (ev: any, item: any) =>
        reduceChildRoutes({
          ev,
          item,
          path,
          openMenu,
          setOpenMenu,
          userData,
        }),
      []
    )}
  </SubMenuWrapper>
);


const reduceChildRoutes = ({
  ev,
  path,
  item,
  openMenu,
  setOpenMenu,
  userData,
}: {
  ev: JSX.Element[];
  userData: any;
  path: string;
  item: MenuItem;
  openMenu: string[];
  setOpenMenu: Function;
}): Array<JSX.Element> => {
  if (item.name) {
    const key = item.name;
    const array = [];
    const exactMatch = item.link
      ? !!matchPath(
          {
            path: item.link,
            end: false,
          },
          path
        )
      : false;
    if (item.children) {
      const partialMatch = item.link
        ? !!matchPath(
            {
              path: item.link,
              end: false,
            },
            path
          )
        : false;
      array.push(key);
      if (
        
        (userData?.userType === "SuperAdmin" &&
          item?.superAdminView !== false) ||
        (userData?.userType !== "SuperAdmin" &&
          item?.adminView === true) ||
        item?.children?.some((childe) =>
          childe?.adminView === true ||
          userData?.permissions?.includes(childe?.permission)
        )
      ) {
        ev.push(
          <SidebarMenuItem
            key={key}
            active={partialMatch}
            open={partialMatch}
            name={item.name}
            icon={iconForMenu(item.name, item.icon)}
            link={item.link}
            badge={item.badge}
            openMenu={openMenu}
            setOpenMenu={setOpenMenu}
            menus={item}
          >
            {renderSidebarMenuItems({
              path,
              items: item.children,
              openMenu,
              userData,
              setOpenMenu,
            })}
          </SidebarMenuItem>
        );
      }
    } else {
      if (
        (userData?.userType === "SuperAdmin" &&
          item?.superAdminView !== false) ||
        (userData?.userType !== "SuperAdmin" &&
          item?.adminView === true) ||
        userData?.permissions?.includes(item?.permission)
      ) {
        ev.push(
          <SidebarMenuItem
            key={key}
            active={exactMatch}
            name={item.name}
            link={item.link}
            badge={item.badge}
            icon={iconForMenu(item.name, item.icon)}
            openMenu={openMenu}
            setOpenMenu={setOpenMenu}
            menus={item}
          />
        );
      }
    }
  }
  return ev;
};



function SidebarMenu(props: any) {
  const location = useLocation();
  const [openMenu, setOpenMenu] = useState<any>([]);
  const { routes } = useContext(SidebarContext);
  const sideMenuItems = mergeMenuItems(routes, true);
  return (
    <>
      {sideMenuItems.map((menuItem: any, index: any) => (
        <span key={index}>
          {renderSidebarMenuItems({
            items: menuItem.items,
            path: location.pathname,
            openMenu,
            setOpenMenu,
            userData: { ...props?.userData },
          })}
        </span>
      ))}
    </>
  );
}

export default SidebarMenu;
